import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth.js'
import error from './error.js'
import news from './news.js'
import loading from './loading.js'
import status from './status.js'
import users from './users.js'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    error,
    news,
    loading,
    status,
    users,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'InfoShare',
      paths:
      [
        'auth.user',
        'auth.hasToken',
        'users.newsList',
        'users.groupList',
        'status.news_edit_item',
      ]
    })
  ] // この行でvuexに「vuex-persistedstate」を追加
})

export default store